export default {
	acceptTermsMiddle: "and the",
	acceptTermsPrefix: "I have read and agree to the",
	alreadyHaveAccount: "Already have an account?",
	joinAsMember: "Join as Member",
	joinAsMemberDesc: "I was invited by a temple to join the team",
	viewPlans: "View plans & pricing",
	viewPlansDesc: "Build your plan — base plus any add-ons you want — and see the price",
	login: "Log in",
	privacyPolicy: "Privacy Policy",
	registerTemple: "Register my Temple",
	registerTempleDesc: "I am a leader or administrator of a temple and want to register it in the system",
	subtitle: "Choose how you want to get started",
	termsOfUse: "Terms of Use",
	termsRequired: "You must accept the terms to continue",
	welcome: "Welcome to ORI",
};
